import SJWT from '@paweljarema/sjwt'

if (!global.JWT) {
    const APP_SECRET = process.env.APP_SECRET
    const TTL = 24 * 60 * 60 * 1000
    const sjwt = new SJWT({ secret: APP_SECRET })
    global.JWT = {
        encode: (object, ttl = TTL) => object && sjwt.tokenize({
            ...object,
            expires: Date.now() + ttl
        }),

        decode: (jwt) => {
            const data = jwt && sjwt.parse(jwt)
            const isValid = data && data.expires >= Date.now()
            return isValid
                ? data
                : false
        }
    }
}



export default global.JWT